







































import { Component } from 'vue-property-decorator';
import { DxLoadPanel, DxScrollView } from 'devextreme-vue';

import { Page } from '@/core/components/controls';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import {
    CONTRACTS,
    FetchServiceContract,
    EventsServiceContract,
    Events,
} from '@/core/contracts';
import { getTableCaption } from '@/core/components/table';

import {
    ComponentData,
    HeaderData,
    SiteGroup,
    LocalizationKeys,
} from './classes';
import { Header, SiteGroup as SiteGroupComponent } from './components';
import { SettingsState } from '@/store';
import { ClientSettingTypeEnum } from '@/dto';
import { debounce } from 'lodash';
import config from '@/config';

@Component({
    components: {
        DxLoadPanel,
        DxScrollView,
        Header,
        SiteGroupComponent,
    },
    filters: {
        tableCaption: (key: string) => getTableCaption(key),
    },
})
export default class OperationalPlanSummaryPage extends Page {
    public LocalizationKeys = LocalizationKeys;

    private readonly eventSubsriptions = [
        {
            eventName: Events.ProcessingFinished,
            handler: this.loadData,
        },
    ];

    @Inject(CONTRACTS.FetchService)
    private fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.EventsService)
    private eventsService?: EventsServiceContract;

    private componentData: ComponentData = new ComponentData();
    private filterKey = 'operationPlanFilter';

    private debouncedResize = debounce(
        this.componentsResize.bind(this),
        config.events.chartResizeDelay
    );

    public get isDataLoaded(): boolean {
        return this.componentData.isFirstStageLoaded;
    }
    public get headerData(): HeaderData {
        return this.componentData.headerData;
    }
    public get siteGroups(): SiteGroup[] {
        return this.componentData.siteGroups;
    }

    public created() {
        this.loadData();
    }

    public mounted() {
        this.subscribeEvents();
    }

    public resized() {
        this.debouncedResize();
    }

    public componentsResize() {
        const siteGroupRef = 'SiteGroupComponent';
        const incomeMtrChartRef = 'IncomeMtrChart';
        const outcomeMtrChartRef = 'OutcomeMtrChart';
        const componenets = this.$refs[siteGroupRef] as any[];

        componenets.forEach(el => {
            (el.$refs[incomeMtrChartRef] as any)
            ?.onResize();
            (el.$refs[outcomeMtrChartRef] as any)
            ?.onResize();
        });
    }

    public loadData() {
        if (!this.fetchService) {
            throw new Error('fetchService is not set');
        }

        const filterValue =
            SettingsState.contextSettings.global[this.filterKey];
        this.componentData.filter = filterValue ? JSON.parse(filterValue) : {};
        this.componentData.load(this.fetchService);
    }

    private async beforeDestroy() {
        this.unsubscribeEvents();
    }

    private onFilterSelected(filter: any) {
        if (!this.fetchService) {
            throw new Error('fetchService is not set');
        }

        const saveValue = JSON.stringify(filter);
        SettingsState.contextSettings.global[this.filterKey] = saveValue;
        SettingsState.changeService!.changeSetting(
            this.filterKey,
            saveValue,
            ClientSettingTypeEnum.Context
        );
        this.componentData.filter = filter;
        this.componentData.load(this.fetchService);
    }

    /**
     * Subscribe to events according eventSubsriptions declarations
     */
    private subscribeEvents() {
        this.eventSubsriptions.forEach(event => {
            this.eventsService!.on(event.eventName, event.handler);
        });
    }

    /**
     * Unsubscribe from events according eventSubsriptions declarations
     */
    private unsubscribeEvents() {
        this.eventSubsriptions.forEach(subscription => {
            this.eventsService!.off(
                subscription.eventName,
                subscription.handler
            );
        });
    }
}
